<ng-container *ngIf="state?.items">
  <ng-container *ngFor="let item of state.items">
    <ng-container [ngSwitch]="item.type">
      <ng-container *ngSwitchCase="FILTERTYPE.DateRange">
        <div class="pill-filter d-inline-block">
          <span>{{ item.customLabel }}</span>
          <i class="fa fa-times remove" aria-hidden="true" (click)="customRefine(item.refinements)"></i>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngFor="let refinement of item.refinements">
          <div class="pill-filter d-inline-block">
            <span>{{ refinement.customLabel || item.customLabel }}</span>
            <i class="fa fa-times remove" aria-hidden="true" (click)="state.refine(refinement)"></i>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="d-inline-block">
    <ng-container *ngIf="showClearAll && state.items.length > 0; else NoRefinements">
      <button type="button" class="btn btn-link" (click)="clearAll()">
        Clear All
      </button>
    </ng-container>
    <ng-template #NoRefinements>
      <span class="d-block m-2">None</span>
    </ng-template>
  </div>
</ng-container>